const hideText = () => {
	const more = 	document.querySelectorAll('.case__more');
	more.forEach((item) => {
		item.addEventListener('click', (event) => {
			const target = event.currentTarget;
			const parent = target.closest('.case__text');
			const text = parent.querySelector('.case__text--hide');
			text.classList.add('show');
			target.classList.add('is-hidden');
		});
	});
};

export {
	hideText,
};
